"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonDetailsView = void 0;
var vue_property_decorator_1 = require("vue-property-decorator");
var BaseView_1 = require("@shared/views/BaseView");
var moment_1 = __importDefault(require("moment"));
var PersonDetailsView = /** @class */ (function (_super) {
    __extends(PersonDetailsView, _super);
    function PersonDetailsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.age = null;
        _this.born = null;
        _this.died = null;
        return _this;
    }
    /** Calculates dates to determine age */
    PersonDetailsView.prototype.calculateDates = function () {
        var lastDay = new Date();
        if (this.model.deathYear && this.model.deathMonth && this.model.deathDay) {
            var death = moment_1.default(this.model.deathYear + "-" + this.model.deathMonth.toString().padStart(2, '0') + "-" + this.model.deathDay.toString().padStart(2, '0'));
            this.died = death.format('MMMM DD, YYYY');
            lastDay = death.toDate();
        }
        if (this.model.birthYear && this.model.birthMonth && this.model.birthDay) {
            var birth = moment_1.default(this.model.birthYear + "-" + this.model.birthMonth.toString().padStart(2, '0') + "-" + this.model.birthDay.toString().padStart(2, '0'));
            this.born = birth.format('MMMM DD, YYYY');
            var last = moment_1.default(lastDay);
            this.age = last.diff(birth, 'years');
        }
    };
    __decorate([
        vue_property_decorator_1.Watch('model', { immediate: true, deep: true })
    ], PersonDetailsView.prototype, "calculateDates", null);
    return PersonDetailsView;
}(BaseView_1.BaseView));
exports.PersonDetailsView = PersonDetailsView;
